<template>
  <div v-if="bannerData?.enabled" :class="statusClass">
    <div class="page-container py-1 flex gap-1 items-center justify-center">
      <WarningIcon class="size-4" />
      <span class="font-semibold">{{ $t(bannerData.label) }}:</span>{{ $t(bannerData.message) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { isLocal, isTest } from "@/config";
import { ref, onMounted, computed } from "vue";
import WarningIcon from "~icons/ic/baseline-info";

const bannerData = ref();

onMounted(async () => {
  try {
    if (isLocal) return;

    const response = await fetch(
      isTest
        ? "https://cdn.xs2event.com/files-test/banner.json"
        : "https://cdn.xs2event.com/files-production/banner.json"
    );
    if (response.ok) {
      bannerData.value = await response.json();
    } else {
      console.error("Failed to load banner data");
    }
  } catch (error) {
    console.error("Error fetching banner data:", error);
  }
});

const statusClass = computed(() => {
  if (!bannerData.value) return undefined;

  const status = bannerData.value.status;

  if (status == "success") {
    return "bg-success-muted text-success-muted-foreground";
  }

  if (status == "error") {
    return "bg-error-muted text-error-muted-foreground";
  }

  if (status == "info") {
    return "bg-info-muted text-info-muted-foreground";
  }

  if (status == "warning") {
    return "bg-warning-muted text-warning-muted-foreground";
  }

  return "bg-primary bg-primary-foreground";
});
</script>
